var ThemeTonalRange;
(function (ThemeTonalRange) {
    ThemeTonalRange["BRIGHT"] = "bright";
    ThemeTonalRange["ULTRA_LIGHT"] = "ultra-light";
    ThemeTonalRange["VERY_DARK"] = "very-dark";
    ThemeTonalRange["VERY_LIGHT"] = "very-light";
})(ThemeTonalRange || (ThemeTonalRange = {}));
export default ThemeTonalRange;
//# sourceMappingURL=theme-tonal-range.js.map